module.exports = __webpack_public_path__ + "img/jizan.76392e03.png";